import { TOUR_IDS } from "@bcc/components/tour/tour-ids";
import { AppLayout } from "@bcc/components/app-layout";
import { VendorContext } from "@client-shared/providers/vendor";
import type { VendorRegion } from "@shared/services/pim/types";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

export interface RegionContact {
  email: string;
  contactName?: string;
}

export const REGION_CONTACTS: Record<VendorRegion, RegionContact> = {
  BDE: { email: "Michael.Bell@sageappliances.com" },
  BUK: { email: "Michael.Bell@sageappliances.com" },
  BUS: { email: "sarah.dooley@breville.com" },
  BAU: { contactName: "Hugh McDonnell", email: "hugh.mcdonnell@breville.com" },
};

export function ContactUsPage() {
  const { t } = useTranslation();
  const [{ currentVendor }] = useContext(VendorContext);

  const region = currentVendor?.region as VendorRegion | undefined;
  const regionContact = region ? REGION_CONTACTS[region] : undefined;
  const email = regionContact?.email ?? t("views.contactUs.email");
  const description = regionContact?.contactName ? t("views.contactUs.descriptionExtended") : t("views.contactUs.description");

  return (
    <AppLayout>
      <div className="p-8" data-tour-id={TOUR_IDS.contactUs.page}>
        <h1 className="mb-4 text-2xl font-semibold">{t("views.contactUs.title")}</h1>
        <p className="text-muted-foreground">
          {description}{" "}
          {regionContact?.contactName ? (
            <>
              {regionContact.contactName} (
              <a href={`mailto:${email}`} className="text-primary underline hover:text-primary/80">
                {email}
              </a>
              {")"}
            </>
          ) : (
            <a href={`mailto:${email}`} className="text-primary underline hover:text-primary/80">
              {email}
            </a>
          )}
          {"."}
        </p>
      </div>
    </AppLayout>
  );
}
